// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"c3de9f6b","977":"23814c44"}[chunkId] + ".chunk.js";
};